export default __webpack_public_path__ + "static/assets/963ae0ec26486c12da2ff71f88db604c.jpg";